// extracted by mini-css-extract-plugin
export default {"greyColor":"var(--color_text_secondary, #738295)","axis":"axis_gPewP","container":"container_SOJDF"};